"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgFeather = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M32.947 16.043a7.003 7.003 0 010 9.904l-6.739 6.76A1 1 0 0125.5 33h-8.086l-2.707 2.707a1 1 0 01-1.414-1.414l2.706-2.707L16 23.5a1 1 0 01.293-.707l6.75-6.75a7.003 7.003 0 019.904 0zM27.078 29h-5.664l-2 2h5.67l1.994-2zm-2.62-11.543L18 23.914l-.001 5.672 9.294-9.293a1 1 0 011.414 1.414L23.414 27H29l.068.004 2.464-2.47a5.004 5.004 0 10-7.075-7.077z",
    id: "feather_svg__a"
  }));
};

var _default = SvgFeather;
exports.default = _default;